module.exports = __webpack_public_path__ + "b71cde8751f4f4fedc93a6d5827b317f.MP3";